import classNames from "classnames"
import React from "react"

import PillButton from "@components/elements/V2/Buttons/PillButton"
import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"

interface QuoteTextCardProps {
  title: string
  quote: string
  image: string
  name: string
  occupation: string
  ctaLink?: string | YocoCom.YocoLink
  ctaText?: string
  backgroundColor?: Color
  style?: "title" | "quote"
}

const QuoteTextCard = ({
  title,
  quote,
  image,
  name,
  occupation,
  ctaLink,
  ctaText,
  backgroundColor = Color.White,
  style = "title",
}: QuoteTextCardProps) => {
  const isQuoteProminent = style === "quote"

  return (
    <div
      className={classNames(
        "col-span-full ml-0 flex flex-col justify-center gap-32 sm:col-span-2 sm:ml-32 md:col-span-3 lg:col-span-6",
        getBackgroundColorClass(backgroundColor)
      )}
    >
      <div className="flex flex-col gap-20">
        <div className="flex flex-col gap-8 sm:gap-20">
          <Typography
            text={title}
            size={isQuoteProminent ? "body-lg" : "h5"}
            font="grotesk"
            weight="medium"
            color={getAccentColor(backgroundColor)}
          />
          <Typography
            text={`"${quote}"`}
            size={isQuoteProminent ? "lead-lg" : "body-lg"}
            font="grotesk"
            weight="book"
            color={getAccentColor(backgroundColor)}
            className="md:max-w-[80%]"
          />
        </div>
        <div className="flex gap-20">
          <GatsbyStoryblokImage
            image={image}
            alt={name}
            className="h-[44px] w-[44px] rounded-full"
          />
          <div className="flex flex-col justify-center gap-[2px]">
            <Typography
              text={name}
              size="body-md"
              font="grotesk"
              weight="medium"
              color={getAccentColor(backgroundColor)}
            />
            <Typography
              text={occupation}
              size="body-md"
              font="grotesk"
              weight="book"
              color={getAccentColor(backgroundColor)}
              className="opacity-50"
            />
          </div>
        </div>
      </div>
      {ctaText && ctaLink && (
        <PillButton
          text={ctaText}
          linkUrl={ctaLink}
          color={Color.Blue}
          style="bordered"
          size="medium"
        />
      )}
    </div>
  )
}

export default QuoteTextCard
